import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography, Card,
  Input, Button,
  Popover,
  Layout, Skeleton,
  Table, Select, Pagination,
  DatePicker
} from "antd";
import dayjs from "dayjs";
import { FaSearch, FaFilter, FaLongArrowAltLeft } from "react-icons/fa";
import { AiOutlineEye } from "react-icons/ai";
import { Get } from "../../config/api/get";
import { LESSON } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../upcoming-lessons/upcoming-lessons.css";
import "./completed-lessons.css";

function CompletedLessons() {
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lessons, setLessons] = useState([])
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();


  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;


  useEffect(() => {
    getLessons();
    // eslint-disable-next-line
  }, []);



  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getLessons(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      status: value,
    });
  };


  const handleTypeChange = (value) => {
    setFilter({
      ...filter,
      type: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getLessons(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };




  const getLessons = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(LESSON.getCompletedLessons, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        status: reset ? "" : filter.status || null,
        type: reset ? "" : filter.type || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });
      setLoading(false);
      if (response?.status) {
        setLessons(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        message.error(response.message);
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };


  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="upcoming-lessons-pager-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="upcoming-lessons-pager-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "_id",
      key: "_id",
      render: (item) => (
        <button
          type="button"
          className="upcoming-lessons-view-btn"
          aria-label="View lesson detail"
          onClick={() => navigate("/lesson-detail/" + item)}
        >
          <AiOutlineEye className="upcoming-lessons-view-icon" aria-hidden="true" />
        </button>
      ),
    },
    {
      title: "S. No.	",
      dataIndex: "key",
      key: "key",
      width: 100,
      render: (value, item, index) => (
        <span className="upcoming-lessons-index">
          {(index < 9 ? "0" : "") + (index + 1)}
        </span>
      ),
    },
    {
      title: "Lesson ID",
      dataIndex: "lessonId",
      key: "lessonId",
      render: (id) => (
        <span className="upcoming-lessons-cell-id">{id}</span>
      ),
    },
    // {
    //   title: "Trainer/Consultant Name",
    //   dataIndex: "coach",
    //   key: "coach",
    //   render: (item) => <span>{item.firstName + " " + item.lastName}</span>,
    // },
    {
      title: "Lesson Date",
      dataIndex: "lessonDate",
      key: "lessonDate",
      render: (item) => (
        <span className="upcoming-lessons-cell-date">
          {dayjs(item).format("M/D/YYYY")}
        </span>
      ),
    },
    {
      title: "Lesson Charge",
      dataIndex: "charges",
      key: "charges",
      render: (item) => (
        <span className="upcoming-lessons-cell-money">${item}</span>
      ),
    },
    {
      title: "Lesson Type",
      dataIndex: "lessonType",
      key: "lessonType",
      render: (val) => (
        <span className="upcoming-lessons-type-pill">{val}</span>
      ),
    },
  ];

  const filterContent = (
    <div className="filterDropdown upcoming-lessons-filter-popover">
      <p className="upcoming-lessons-filter-head">Filter lessons</p>
      <hr />

      <div className="filterDropdownBody">
        <p className="mainLabel">Lesson Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          placeholder="From"
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          placeholder="To"
        />

        <p className="mainLabel">Lesson Type:</p>

        <Select
          size={"large"}
          className="filterSelectBox upcoming-lessons-filter-select"
          placeholder="Select Lesson Type"
          value={filter.type}
          onChange={(e) => handleTypeChange(e)}
          options={[
            { value: "TUTORING", label: "Training" },
            { value: "COACHING", label: "Consulting" },
          ]}
        />

        <p className="mainLabel">Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox upcoming-lessons-filter-select"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          options={[
            { value: "PENDING", label: "Pending" },
            { value: "UPCOMING", label: "Upcoming" },
          ]}
        />

        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton upcoming-lessons-filter-apply"
          onClick={() => getLessons()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );



  return (
    <Layout className="upcoming-lessons-page" style={{ minHeight: "100vh" }}>
      <Row className="compltedBackground upcoming-lessons-hero">
        <button
          type="button"
          className="upcoming-lessons-hero-back"
          aria-label="Go back"
          onClick={() => navigate(-1)}
        >
          <FaLongArrowAltLeft className="upcoming-lessons-hero-back-icon" aria-hidden="true" />
        </button>
        <Typography.Title
          level={1}
          className="fontFamily1 aboutbanner-content upcoming-lessons-hero-title"
        >
          Completed Lessons
        </Typography.Title>
      </Row>

      <Row className="whiteBackground upcoming-lessons-section">
        <Col xs={24} lg={22} xl={21}>
          <div className="upcoming-lessons-inner">
            <Card className="infoBox upcoming-lessons-card" bordered={false}>
              <div className="boxDetails upcoming-lessons-box">
                <Row className="upcoming-lessons-toolbar" gutter={[16, 16]}>
                  <Col xs={24} md={12} className="upcoming-lessons-toolbar-intro">
                    <p className="upcoming-lessons-toolbar-kicker">History</p>
                    <h2 className="upcoming-lessons-toolbar-title">
                      Completed sessions
                    </h2>
                    <p className="upcoming-lessons-toolbar-sub">
                      Review past lessons by date, type, and status, or search to
                      open a lesson detail quickly.
                    </p>
                  </Col>
                  <Col xs={24} md={12} className="upcoming-lessons-toolbar-actions">
                    <Popover
                      content={filterContent}
                      trigger="click"
                      open={open}
                      onOpenChange={handleOpenChange}
                      placement="bottomRight"
                      arrow={false}
                    >
                      <Button
                        type="primary"
                        shape="circle"
                        className="upcoming-lessons-filter-trigger"
                        aria-label="Open filters"
                      >
                        <FaFilter style={{ fontSize: 16, color: "white" }} />
                      </Button>
                    </Popover>
                    <Input
                      className="mainInput dashInput upcoming-lessons-search"
                      placeholder="Search lessons…"
                      onChange={(e) => handleSearch(e.target.value)}
                      suffix={
                        <FaSearch
                          style={{
                            color: "#64748b",
                            fontSize: 16,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            getLessons(1, paginationConfig.limit, filter.keyword)
                          }
                        />
                      }
                      onPressEnter={() =>
                        getLessons(1, paginationConfig.limit, filter.keyword)
                      }
                    />
                  </Col>
                </Row>

                <Row className="upcoming-lessons-table-shell">
                  {loading ? (
                    <div className="upcoming-lessons-skeleton-wrap">
                      <Skeleton active paragraph={{ rows: 6 }} />
                    </div>
                  ) : (
                    <div className="upcoming-lessons-table-wrap">
                      <Table
                        className="styledTable upcoming-lessons-table"
                        dataSource={lessons}
                        columns={columns}
                        pagination={false}
                        rowKey={(record, index) =>
                          record._id ?? record.lessonId ?? `lesson-row-${index}`
                        }
                        scroll={{ x: "max-content" }}
                      />
                    </div>
                  )}
                </Row>

                <Row className="upcoming-lessons-pagination-row" gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                    <p className="fontFamily1 upcoming-lessons-pagination-meta">
                      {message}
                    </p>
                  </Col>
                  <Col xs={24} md={12}>
                    <div className="upcoming-lessons-pagination-controls">
                      <Pagination
                        className="styledPagination"
                        onChange={(e) => handlePageChange(e)}
                        current={parseInt(paginationConfig.pageNumber)}
                        pageSize={paginationConfig.limit}
                        total={paginationConfig.totalDocs}
                        itemRender={itemRender}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default CompletedLessons;
